import React from 'react';
import { HeartPulseIcon, ShieldCheckIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { images } from '../../data/content';
const trust = [{
  icon: ZapIcon,
  label: 'Instant access'
}, {
  icon: CreditCardIcon,
  label: 'One-time payment'
}, {
  icon: ShieldCheckIcon,
  label: '7-day guarantee'
}];
export function Hero() {
  return <header className="bg-navy-950 text-white" data-id="element-222" data-mp="muk663uuka72">
      <div className="bg-cta px-4 py-2 text-center text-xs font-extrabold text-navy-950 sm:text-sm" data-id="element-223" data-mp="mts9eppik6f7">
        Introductory offer: the complete collection for $27 USD — one-time payment
      </div>

      <div className="mx-auto grid max-w-6xl gap-8 px-4 pb-16 pt-8 sm:pt-12 lg:grid-cols-2 lg:gap-x-14 lg:pb-24 lg:pt-16" data-id="element-224" data-mp="vmvsbdixhbh8">
        <div data-id="element-225" data-mp="10n9u4dtxrp6t">
          <p className="flex items-center gap-2 text-sm font-extrabold tracking-wide text-brand" data-id="element-226" data-mp="15kiac8vixj5f">
            <HeartPulseIcon className="h-5 w-5" aria-hidden="true" data-id="element-227" data-mp="1ajmntbphe31k" />
            CRITICAL CARE NURSING BLUEPRINT™
          </p>
          <h1 className="mt-4 text-[34px] font-black leading-[1.05] tracking-tight text-balance sm:text-5xl lg:text-[58px]" data-id="element-228" data-mp="9o2pjkgwyomj">
            Master essential critical care concepts in{' '}
            <span className="text-cta" data-id="element-229" data-mp="3vuhip6a3vdt1">15 minutes a day</span>
          </h1>
          <p className="mt-4 text-lg font-bold text-brand sm:text-xl" data-id="element-230" data-mp="3rtffyfgzcjmb">
            With a structured 6-volume nursing reference system
          </p>
          <p className="mt-4 text-base leading-relaxed text-mist sm:text-lg" data-id="element-231" data-mp="sczagxqf84s3">
            A practical educational reference system designed to help you organize critical care nursing knowledge,
            review essential monitoring concepts, and develop a more structured approach to clinical reasoning.
          </p>
          <div className="mt-6 flex items-center gap-3" data-id="element-232" data-mp="emnh6vi3nzzd">
            <img src={images.rachel} alt="Rachel Bennett" className="h-12 w-12 rounded-full object-cover object-top ring-2 ring-brand" data-id="element-233" data-mp="1b51vela3i785" />
            <p className="text-sm leading-tight" data-id="element-234" data-mp="30ldwuwl6zsk9">
              <span className="block font-bold text-white" data-id="element-235" data-mp="30mp9llwm8ani">By Rachel Bennett</span>
              <span className="text-mist" data-id="element-236" data-mp="35jp91dyymf5n">Critical care nursing educator</span>
            </p>
          </div>
        </div>

        <div className="lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:self-center" data-id="element-237" data-mp="2qu1h33co4sul">
          <img src={images.mockup} alt="The Critical Care Nursing Blueprint: 6 volumes and 5 bonuses" className="mx-auto w-full max-w-xl" data-id="element-238" data-mp="2vte1lhg2hnu0" />
          <p className="mx-auto mt-4 max-w-xl text-center text-sm font-semibold text-mist" data-id="element-239" data-mp="2mvafaix9cn15">
            Includes 6 premium volumes, 5 exclusive bonuses, and practical educational tools covering hemodynamic
            monitoring, respiratory assessment, neurological evaluation, laboratory interpretation, and critical care
            case studies.
          </p>
        </div>

        <div data-id="element-240" data-mp="b585r2semr6s">
          <div className="rounded-3xl bg-navy-900 p-5 ring-1 ring-white/10 sm:p-6" data-id="element-241" data-mp="b3oop9yxcc3y">
            <div className="flex items-end justify-between gap-4" data-id="element-242" data-mp="1vm8uqha63t74">
              <div data-id="element-243" data-mp="1qnxqqn6k0cwt">
                <p className="text-xs font-extrabold uppercase tracking-wider text-mist" data-id="element-244" data-mp="1qofqhtsfd99h">The introductory offer</p>
                <p className="mt-1 flex items-baseline gap-2" data-id="element-245" data-mp="25dvfp5cb56n2">
                  <span className="text-6xl font-black leading-none text-white" data-id="element-246" data-mp="20mdgalpxne47">$27</span>
                  <span className="text-lg font-bold text-mist" data-id="element-247" data-mp="2edi7r0j5d03g">USD</span>
                </p>
              </div>
              <div className="text-right" data-id="element-248" data-mp="2ac6pxh6ilj5t">
                <p className="text-base font-bold text-mist line-through decoration-danger decoration-2" data-id="element-249" data-mp="2ab55wn7itmby">$237</p>
                <p className="text-sm font-extrabold text-success-bright" data-id="element-250" data-mp="2oawo7052lovr">One-time payment</p>
              </div>
            </div>
            <CTAButton id="first-cta" label="Get the complete Blueprint™ now" className="mt-5" data-id="element-251" data-mp="txncr2syrtav" />
            <p className="mt-3 text-center text-xs font-medium text-mist sm:text-sm" data-id="element-252" data-mp="oyk5dbpihazq">
              Instant digital access · One-time payment of $27 USD · No monthly subscription
            </p>
            <ul className="mt-5 grid grid-cols-3 gap-2 border-t border-white/10 pt-4" data-id="element-253" data-mp="qi3qrvpec659">
              {trust.map(({
              icon: Icon,
              label
            }) => <li key={label} className="flex flex-col items-center gap-1 text-center" data-id="element-254" data-mp="10eykm1aq5id7">
                  <Icon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-255" data-mp="15d9wsiohs4yl" />
                  <span className="text-[11px] font-bold leading-tight text-white sm:text-xs" data-id="element-256" data-mp="7phvbcieihl7">{label}</span>
                </li>)}
            </ul>
          </div>
          <p className="mt-4 text-xs leading-relaxed text-mist/80" data-id="element-257" data-mp="cm87vpuzyv1v">
            The 15-minute reference refers to a focused study session, not a complete clinical assessment or a
            guarantee of clinical competency. Seven-day satisfaction guarantee, subject to the published refund policy.
          </p>
        </div>
      </div>
    </header>;
}